import { console } from 'react-redux-app/lib/modules/core/utils';

import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';

import { actionLoadSiteFooterLinksRequest } from '../../actions/loadSiteFooterLinks';

import { getLoadSiteFooterLinksError } from '../../selectors/errors';


export default ({ getState, dispatch }) => (
  function loadSiteFooterLinksHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadSiteFooterLinksRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadSiteFooterLinksError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadSiteFooterLinksHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
